<template>
    <header class="fixed lg:relative inset-x-0 bg-white z-20">
        <!--
        <div class="hidden lg:block bg-yellow">
            <div class="container py-4 text-center">
                Prodloužili jsme přihlašování do Yody a to do 19. 11. Pro přihlášení klikni na tlačítko „Přihlásit se“ a vyplň přihlášku. Těšíme se na Tebe!
            </div>
        </div>
        -->
        <div class="lg:mb-12 container">
            <nav
                class="flex flex-wrap items-center justify-between lg:w-3/4 py-4 lg:py-6 mx-auto bg-teal-500"
            >
                <Link href="/" class="flex items-center flex-shrink-0 pr-7">
                    <img
                        src="/img/yoda.svg"
                        class="pr-5 img-fluid"
                        alt="logo"
                        title="logo"
                    />
                    <span class="text-xl">Yoda Mentorship</span>
                </Link>
                <div class="block lg:hidden">
                    <button
                        @click="show = !show"
                        class="flex items-center px-3 py-2 text-teal-200"
                    >
                        <svg
                            class="w-3 h-3 fill-current"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <title>Menu</title>
                            <path
                                d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"
                            />
                        </svg>
                    </button>
                </div>
                <div
                    class="w-full lg:w-2/3 lg:items-center flex-col lg:flex-row py-4 lg:py-0"
                    :class="{ 'hidden lg:flex': !show, flex: shows }"
                >
                    <div
                        class="flex flex-col lg:flex-row mb-4 lg:mb-0 leading-loose"
                    >
                        <Link @click="show = false" class="" href="/o-nas"
                            >O nás</Link
                        >
                        <Link
                            @click="show = false"
                            class="lg:mx-10 2xl:mx-16"
                            href="/mentori"
                        >
                            Mentoři
                        </Link>
                        <Link
                            @click="show = false"
                            class="lg:mr-10 2xl:mr-16"
                            href="/blog"
                        >
                            Blog
                        </Link>
                        <Link
                            @click="show = false"
                            class="lg:mr-10 2xl:mr-24"
                            href="/kontakt"
                        >
                            Kontakt
                        </Link>
                    </div>
                    <a
                        class="px-5 py-2 text-white bg-blue hover:bg-black hover:text-white rounded-3xl transition duration-300"
                        href="https://forms.gle/zhkSk6yGQxr3427g9"
                        target="_blank"
                    >
                        Přihlásit se
                    </a>
                </div>
            </nav>
        </div>
    </header>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'

export default {
    data() {
        return {
            show: false,
        }
    },

    components: {
        Link,
    },
}
</script>
